module.exports = __webpack_public_path__ + "static/img/infarma_badge_2663_Warszawa_2020-03-07.d936afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infarma_badge_2663_Warszawa_2020-03-07.png
// module id = rlRP
// module chunks = 1